<template>
  <div
    :class="{
      'fluid-container': true,
    }"
  >
    <section
      :class="{
        'mx-auto w-full px-4 py-12': true,
      }"
    >
      <EventFormatFilter
        :format-options="formatOptions"
        :selected-format="selectedFormat"
        @format-change="onFormatChange"
      />
      <div>
        <ResourceCenterLoader v-if="isLoading" />
        <!-- If there are no results, show the empty results content -->
        <div v-else-if="paginationResult.items.length === 0">
          <PortableText
            v-if="page.emptyResultsContent?.blogPortableText"
            :portable-data="page.emptyResultsContent.blogPortableText"
          />
        </div>

        <div v-else>
          <!-- In-Person Events Locations on Map -->
          <AllEventsLocationMap
            v-if="selectedFormat === 'inPerson'"
            v-bind="paginationResult"
          />

          <TransitionGroup
            name="event-list"
            tag="div"
          >
            <FilterOptionsCardsContainer
              :class="{
                '[grid-auto-rows:subgrid] md:grid-cols-2 xl:grid-cols-3': true,
              }"
              :card-data="paginationResult.items"
              :is-loading="isLoading"
              data-testid="EventFilterCardsContainer"
            >
              <template #cards>
                <EventCard
                  v-for="event in paginationResult.items"
                  :key="event._id"
                  :event="event"
                />
              </template>
            </FilterOptionsCardsContainer>

            <FilterOptionsPaginationBar
              v-if="paginationResult.items.length > 0"
              :total="paginationResult.total"
              :page-number="pageNumber"
              :page-limit="pageLimit"
              :go-to-page="page.goToPage"
              data-testid="EventFilterPaginationBar"
              @page-change="onPageChange"
            />
          </TransitionGroup>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import FilterOptionsCardsContainer from '~/components/Molecules/ContentFilter/FilterOptionsCardsContainer.vue';
import FilterOptionsPaginationBar from '~/components/Molecules/ContentFilter/FilterOptionsPaginationBar.vue';
import PortableText from '~/components/Atoms/PortableText/PortableText.vue';
import EventFormatFilter from './EventFormatFilter.vue';
import AllEventsLocationMap from './AllEventsLocationMap.vue';
import EventCard from './EventCard.vue';
import type { PageResourceCenterEventsIndexResult } from '~/sanity/types.js';
import ResourceCenterLoader from '~/components/Atoms/ResourceCenterLoader/ResourceCenterLoader.vue';

type EventPageHeroProps = {
  page: NonNullable<PageResourceCenterEventsIndexResult>;
  isFirstLoad: boolean;
};
defineProps<EventPageHeroProps>();
const emit = defineEmits<{
  (e: 'update:isFirstLoad', value: boolean): void;
}>();

const {
  isLoading,
  pageLimit,
  pageNumber,
  paginationResult,
  selectedFormat,
  formatOptions,
  onPageChange,
  onFormatChange,
} = await useEventFilter();
emit('update:isFirstLoad', false);
</script>

<style lang="scss" scoped></style>
